const galleries = new WeakSet();
function initGalleries(scope = document) {
  scope.querySelectorAll('[data-av-gallery]').forEach((gallery) => {
    if (galleries.has(gallery)) return;
    galleries.add(gallery);
    const track = gallery.querySelector('[data-av-gallery-track]');
    const slides = [...gallery.querySelectorAll('[data-av-slide]')];
    const thumbs = [...gallery.querySelectorAll('[data-av-thumb]')];
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    let frame;
    function sync() {
      frame = undefined;
      const index = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
      thumbs.forEach((thumb, i) => i === index ? thumb.setAttribute('aria-current', 'true') : thumb.removeAttribute('aria-current'));
    }
    function select(index, keyboard = false) {
      track.scrollTo({ left: track.clientWidth * index, behavior: reduced.matches || keyboard ? 'instant' : 'smooth' });
    }
    thumbs.forEach((thumb, index) => thumb.addEventListener('click', (event) => {
      event.preventDefault();
      select(index, event.detail === 0);
    }));
    track.addEventListener('scroll', () => {
      if (!frame) frame = requestAnimationFrame(sync);
    }, { passive: true });
    track.addEventListener('keydown', (event) => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const index = Math.round(track.scrollLeft / track.clientWidth);
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : Math.max(0, Math.min(slides.length - 1, index + (event.key === 'ArrowRight' ? 1 : -1)));
      select(next, true);
    });
    sync();
  });
}
initGalleries();
document.addEventListener('shopify:section:load', (event) => initGalleries(event.target));

